export interface EnvironmentalParcelScreen {
  parcel_id_local: string;
  wetlands: { acres: number; pct: number; types: string[] };
  wildfire: {
    metrics: {
      burn_probability: { mean: number };
      characteristic_flame_length: { mean: number; max: number };
    };
    comparison: { all_below_service_mean: boolean };
  };
}

export interface CincoFrioEnvironmentalContext {
  coverage: {
    parcel_count: number;
    adjacent_parcel_count: number;
    parcels_with_nwi_overlap: number;
  };
  subject: EnvironmentalParcelScreen;
  optional_add_on: EnvironmentalParcelScreen;
  adjacent_parcels: EnvironmentalParcelScreen[];
}

function screeningRow(label: string, screen: EnvironmentalParcelScreen) {
  const wetlandAcres = Number(screen.wetlands.acres).toFixed(2);
  const wetlandPct = Number(screen.wetlands.pct).toFixed(2);
  const burnProbabilityPct = (Number(screen.wildfire.metrics.burn_probability.mean) * 100).toFixed(3);
  const flame = screen.wildfire.metrics.characteristic_flame_length;
  const comparison = screen.wildfire.comparison.all_below_service_mean
    ? 'below statewide mean across all five TxWRAP indicators'
    : 'mixed relative to statewide TxWRAP means';
  return {
    label,
    wetlands: `${wetlandAcres} NWI-mapped acres (${wetlandPct}%)`,
    wildfire: `${burnProbabilityPct}% mean annual burn probability · ${Number(flame.mean).toFixed(1)} ft mean flame length (${Number(flame.max).toFixed(1)} ft max) · ${comparison}`,
  };
}

export function buildEnvironmentalScreeningCopy(context?: CincoFrioEnvironmentalContext | null) {
  if (!context) return null;
  return {
    rows: [
      screeningRow('Cinco core', context.subject),
      screeningRow('Boeck optional add-on', context.optional_add_on),
    ],
    adjacent_summary: `Five edge-sharing parcels were screened in the same desktop run; ${context.coverage.parcels_with_nwi_overlap} of ${context.coverage.parcel_count} screened parcels contain NWI-mapped overlap.`,
  };
}
